<mat-form-field class="dict-commission-settlement">
  <mat-label>{{ label }}</mat-label>
  <mat-select [formControl]="control" [required]="required" (selectionChange)="onSelectionChange($event)" [multiple]="multiple">
    <mat-option *ngFor="let cs of filteredItems" [value]="cs.uuid" multiLineOption>
      <h4 mat-line>
        <ng-container *ngIf="cs.partner">
          {{cs.partner?.shortName}},
        </ng-container>
        <ng-container *ngIf="cs.ofwca">
          {{cs.ofwca.fullName}},
        </ng-container>
        {{ cs.status.name }} (nr: {{cs.number}})
      </h4>
      <p mat-line>
        Zawarta {{cs.billingMonth | date:'y-MM-dd'}},
        Status: {{cs.status.name}}
      </p>
    </mat-option>
  </mat-select>
  <button *ngIf="((control.value !== null
    && multiple && control.value.hasOwnProperty('length')
    && control.value.length > 0) || (!multiple && control.value))
    && !required"
          matSuffix
          mat-icon-button
          type="button"
          aria-label="Clear"
          (click)="clearValue(); $event.stopPropagation()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
  <mat-error *ngIf="control.hasError('backendError')">{{control.getError('backendError')}}</mat-error>
</mat-form-field>
